import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../../rootReducer";

export const selectUsersAvailable = createSelector(
    [
        (store: RootState) => store.users.users,
        (store: RootState) => store.profileDetail.userList,
        (store: RootState) => store.profileDetail.addUserSearchText,
        (store: RootState) => store.profileDetail.selectedUsers,
    ],
    (users, userList, searchText, selectedUsers) => {
        const data = users?.filter(
            ({ id, name }) => {
                // Descarta del listado a usuarios ya asignados al perfil
                if (userList.find(({ id: userId }) => userId === id)) {
                    return false;
                }
                // Descarta del listado a usuarios ya esten seleccionados
                if (selectedUsers.find(({ id: userId }) => userId === id)) {
                    return false;
                }
                // Filtra listado de usuarios por nombre
                if (
                    searchText
                    && !name?.toLowerCase().includes(searchText?.toLowerCase().trim())
                ) {
                    return false;
                }
                return true;

            });

        const orderedList = [...data].sort((a, b) => {
            if (a.name && b.name && a.name < b.name) {
                return -1;
            }
            if (a.name && b.name && a.name > b.name) {
                return 1;
            }
            return 0;
        });

        return orderedList;
    }
);